/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';
import { setCustomThumbnails } from '../helpers/assets';
import { setMasterAssets } from './helpers/entityAdapter';

export const setMediaThumbnails = createAction('products/setMediaThumbnails');

const patchAssetPools = (pools, assets) => {
  if (!pools) return;

  Object.keys(pools).forEach((poolId) => {
    const pool = pools[poolId];
    if (!Array.isArray(pool) || !pool.length) return;
    pools[poolId] = setCustomThumbnails(pool, assets);
  });
};

export const reducer = (builder) => {
  builder.addCase(setMediaThumbnails.type, (state, { payload: assets }) => {
    state.items = state.items.map((item) => {
      if (item.assets && item.assets.length) {
        item.assets = setCustomThumbnails(item.assets, assets);
        setMasterAssets(state, item._id, item.assets);
      }
      return item;
    });

    const productAssets = state.entities?.assets;
    if (!productAssets) return;

    patchAssetPools(productAssets.listingAssets, assets);
    patchAssetPools(productAssets.listingVariantAssets, assets);
    patchAssetPools(productAssets.masterAssets, assets);
    patchAssetPools(productAssets.masterVariantAssets, assets);
  });
};
